import Vue from "vue";

export default {
    install () {
        Vue.prototype.$thousandSeprator = function(amount) {
            if (!amount) {
                return 'Undefined';
            }

            if (amount !== '' || amount !== 0 || amount !== '0' || amount !== null) {
                return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            } else {
                return amount;
            }
        };

        Vue.prototype.$addressToString = function(detail) {
            if (detail && detail.fullDetail) {
                return detail.fullDetail;
            } else {
                return '';
            }
        };

        Vue.prototype.$materialStyleString = function(detail) {
            if (!detail.materialStyle) {
                return '--';
            }
            return detail.materialStyle.material.name + " - " + detail.materialStyle.color_name +
                '(' + detail.materialStyle.code + ')';
        };
    },
};